module.exports = __webpack_public_path__ + "img/mine30Bg.c85e51cb.webp";